export const TEAM_CHAT_API_INVALIDATION_KEY = 'stream-chat-token';
export const USERS_QUERY_LIMIT = 50;
export const CHANNELS_QUERY_LIMIT = 30;
export const MESSAGES_QUERY_LIMIT = 25;
export const MAX_CHANNEL_NAME_LENGTH = 64;
export const DELETED_USER_DESIGNATION = 'deleted user';
export const PRIVATE_CHANNEL_PREFIX_DESIGNATION = '!members';
export const CHANNEL_TYPE_TEAM_DESIGNATION = 'team';
export const THREADS_QUERY_LIMIT = 20;
export const USERS_QUERY_STALE_TIME = 5 * 60 * 1000; // 5 minutes
